import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { WintSuperkollAPIModel, WintUtilsWebApi } from "wint-api-client/dist/types";
import { ArticleChartProps, ArticlesWidgetAPIProps } from "models/propTypes/articlePropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { ChartContainer, useMountedState } from "components/common";
//#endregion
import { LocalizationHelperInstance, QueryStateHelper, UrlHelper } from "utils/helpers";
import { useNavigate, useLocation } from "react-router-dom";
import { FormFieldConstants } from "utils/constants";
import { useArticleService } from "serviceHooks";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

const ArticleInvoicedQuantitiesBarChart: React.FC<ArticleChartProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const articleService = useArticleService();
  const { getMounted } = useMountedState();
  const [articleName, setArticleName] = React.useState<string | undefined>();

  React.useEffect(() => {
    articleService.get(props.articleId).then((a) => {
      if (getMounted()) setArticleName(a?.text ?? "");
    });
  }, [props.articleId]);

  const filter: Omit<ArticlesWidgetAPIProps, keyof WintUtilsWebApi.Filter> = {
    articleId: props.articleId,
  };

  const labelFormatter = (label?: string) => (label ? label.substring(0, 3) : "");

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Bar}
      chartAPIKey={GraphConstants.ChartKeys.ArticleComparableMonth}
      accumulatedChartAPIKey={GraphConstants.ChartKeys.ArticleComparableAccountLine}
      filter={filter}
      labelFormatter={labelFormatter}
      dataUnit={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Pc)}
      useClickableChart
      onPeriodClick={async ({ start, end }) => {
        const name = articleName ?? (await articleService.get(props.articleId).then((a) => a?.text ?? ""));
        const params = new URLSearchParams();
        QueryStateHelper.dateRangeQueryEncoder(FormFieldConstants.Invoice.Filter.InvoiceDate).urlEncode(
          params,
          undefined,
          { start, end }
        );
        QueryStateHelper.multipleAutoCompleteItemsQueryEncoder(FormFieldConstants.Invoice.Filter.Articles).urlEncode(
          params,
          undefined,
          [{ id: props.articleId, value: name as string }]
        );
        navigate(`${UrlHelper.formatPath(`/Reports/Revenue/Invoices`)}?${params.toString()}`, {
          state: { background: location },
        });
      }}
    />
  );
};

export default ArticleInvoicedQuantitiesBarChart;
